/**
* @author Andrés Camilo Ferreira Rodríguez
* @Copyright (c) Infotrack. All rights reserved.
*/
export default {
'sidebar.smartstock': 'Smart  Stock',
'sidebar.proveedores': 'Proveedores',
'proveedores.agregarProveedores': 'Create Proveedores',
'proveedores.modificarProveedores': 'Edit Proveedores',
'proveedores.eliminarProveedores': 'Delete Proveedores',
'proveedores.proveedorId': 'Proveedor   Id ',
'proveedores.empresaId': ' Empresa   Id ',
'proveedores.descripcionProveedor': ' Descripcion   Proveedor',
'proveedores.proveedores': 'Proveedores',
'proveedores.verProveedores': 'View Proveedores',
};

